module.exports = __webpack_public_path__ + "files/1cb665017d5888e464036243e4284a88.svg";